<template>
  <d2-container>
    <el-button
      class="filter-item"
      v-permission:function="['competitionClassManger:btn_add']"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="getAdd"
    >添加</el-button>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
      :data="cardData"
    >
      <el-table-column align="center" label="分类id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="分类名称">
        <template slot-scope="scope">
          <span
            @click="getDetails(scope.row.id)"
            style="color:#409eff;cursor: pointer;"
          >{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="420">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="editCard(scope.row.id)"
            v-permission:function="['competitionClassManger:btn_edit']"
            style="margin-top: 10px;"
          >编辑</el-button>
          <el-button
            size="small"
            type="danger"
            v-permission:function="['competitionClassManger:btn_del']"
            @click="delCard(scope.row.id)"
            style="margin-top: 10px;"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="width:500px"
      ></el-pagination>
    </template>
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form" label-width="170px">
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="分类排序" prop="sort">
          <el-input v-model="form.sort" placeholder="请输入分类排序"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')">取 消</el-button>
        <el-button v-if="dialogStatus=='create'" type="primary" @click="create('form')">确 定</el-button>
        <el-button v-else type="primary" @click="update('form')">确 定</el-button>
      </div>
    </el-dialog>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import {
  megagameClassify,
  megagameClassifyRemove,
  megagameClassifyUpdate,
  megagameClassifyAdd,
  megagameClassifyinfo
} from '@/api/demo/competition/index'
export default {
  name: 'competitionClassManger',
  computed: {
    ...mapGetters(['elements'])
  },
  data () {
    return {
      competitionClassManger_btn_add: false,
      competitionClassManger_btn_edit: false,
      competitionClassManger_btn_del: false,

      tableKey: 0,
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        classifyId: ''
      },
      selectedTime: [], // 时间
      cardData: [], // 表格数据
      total: null,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      dialogFormVisible: false,
      form: {
        name: '',
        sort: null
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入分类名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ]
      },
      classId: null // 分类id
    }
  },
  watch: {
    $route (to, from) {
      this.getSearch()
    }
  },
  created () {
    this.getSearch()
    // getOptions().then(res=>{
    //   console.log('resdd',res)
    // })
  },
  mounted () {},
  methods: {
    // 搜索条件
    getSearch (val) {
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      megagameClassify(this.listQuery).then(res => {
        this.listLoading = true
        this.cardData = res.records
        console.log(this.$data, this.$options.data())
        this.total = parseInt(res.total)
        this.listLoading = false
      })
    },
    // 添加
    getAdd () {
      this.dialogStatus = 'create'
      this.form.name = ''
      this.dialogFormVisible = true
    },
    // 编辑
    editCard (id) {
      let that = this
      that.dialogFormVisible = true
      that.dialogStatus = 'update'
      megagameClassifyinfo(id).then(res => {
        console.log('id', res)
        that.form = res
        that.classId = id
      })
    },
    delCard (id) {
      let that = this
      this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          megagameClassifyRemove(id).then(res => {
            that.getSearch()
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
        })
        .catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 添加
    create (formName) {
      let that = this
      const set = that.$refs
      set[formName].validate(valid => {
        if (valid) {
          megagameClassifyAdd(that.form).then(res => {
            that.getSearch()
            that.$message({
              message: '新增成功',
              type: 'success',
              center: true
            })
            that.dialogFormVisible = false
          })
        } else {
          return false
        }
      })
    },
    // 编辑
    update (formName) {
      let that = this
      const set = that.$refs
      set[formName].validate(valid => {
        if (valid) {
          megagameClassifyUpdate(that.classId, that.form).then(res => {
            that.getSearch()
            that.$message({
              message: '修改成功',
              type: 'success',
              center: true
            })
            that.dialogFormVisible = false
          })
        } else {
          return false
        }
      })
    },
    // 取消
    cancel (formName) {
      this.dialogFormVisible = false
      this.$refs[formName].resetFields()
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    },
    // 查询对应的列表
    getDetails (id) {
      this.$router.push({
        path: '../demo/punchTheClock',
        query: {
          id: id
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
